import { Component } from '@angular/core';

@Component({
  selector: 'app-acces-restreint',
  templateUrl: './accès-restreint.component.html',
})
export class AccèsRestreintComponent {}
